/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type VWithVersionRequestBuilder, VWithVersionRequestBuilderNavigationMetadata } from './vWithVersion/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api
 */
export interface ApiRequestBuilder extends BaseRequestBuilder<ApiRequestBuilder> {
    /**
     * Builds and executes requests for operations under /api/v{version}
     * @param version The path parameter: version
     * @returns {VWithVersionRequestBuilder}
     */
     vWithVersion(version: string | undefined) : VWithVersionRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const ApiRequestBuilderUriTemplate = "{+baseurl}/api";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ApiRequestBuilderNavigationMetadata: Record<Exclude<keyof ApiRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    vWithVersion: {
        navigationMetadata: VWithVersionRequestBuilderNavigationMetadata,
        pathParametersMappings: ["version"],
    },
};
/* tslint:enable */
/* eslint-enable */
